import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { RootContext } from '../../RootProvider';
import FourZeroFourView from './FourZeroFourView';
import LoadingView from './LoadingView';
import { RoutePaths } from '../../routes/history';
import { getSearchParam } from 'models/Browser';
import { APIState } from '../../models/APIState';

const AuthenticateView = () => {
  const history = useHistory();
  const { auth } = React.useContext(RootContext);
  React.useEffect(() => {
    if (auth.status !== 'SUCCESS') return;
    let pathname = getSearchParam('pathname');
    let new_route =
      pathname && pathname !== 'authenticate'
        ? `/${pathname}`
        : RoutePaths.DefaultRoute().toString();
    history.push(new_route);
  }, [auth.status, history]);

  if (auth.status === APIState.FAIL) {
    return <FourZeroFourView />;
  } else {
    return <LoadingView />;
  }
};

export default AuthenticateView;
